import { render, staticRenderFns } from "./SearchResultContext.vue?vue&type=template&id=1921f6e3"
import script from "./SearchResultContext.vue?vue&type=script&lang=js"
export * from "./SearchResultContext.vue?vue&type=script&lang=js"
import style0 from "./SearchResultContext.vue?vue&type=style&index=0&id=1921f6e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports